e360.service('emailApi', [
   '$http', 'apiHelper',
   function ($http, apiHelper) {
      return {
         sendInvites: function (params) {
            return apiHelper.post('email/sendInvites', params);
         },
         listTemplates: function (label) {
            var url = 'email/listTemplates';

            if (label) {
               url = url + '?label=' + label;
            }

            return apiHelper.get(url);
         },
         listTags: function () {
            return apiHelper.get('email/listTags');
         },
         templateInfo: function (template) {
            return apiHelper.get('email/templateInfo/' + template);
         },
         csvToJson: function (file) {
            var fd = new FormData();
            fd.append('file', file);
            return $http.post(apiHelper.getApiUrl('email/CsvToJson'), fd, {
               headers: {
                  'Content-Type': undefined
               },
               transformRequest: angular.identity
            });
         },
         sendBulk: function (model) {
            return apiHelper.post('email/SendBulkEmail', model);
         }
      };
   }
]);
